import { getFilingRowRect } from "v2/utils/getFilingRowRect";

export const scrollFilingRowIntoView = (
  list: HTMLElement | null,
  filingId: string
): void => {
  if (!list) return;

  const targetRect = getFilingRowRect(list, filingId, false);
  if (!targetRect) return;

  const listRect = list.getBoundingClientRect();

  const bottomOverflow = targetRect.top + targetRect.height - listRect.bottom;
  const topOverflow = listRect.top - targetRect.top;

  if (bottomOverflow <= 0 && topOverflow <= 0) return;

  const offset = bottomOverflow > 0 ? bottomOverflow : -topOverflow;

  list.scrollTo({ top: list.scrollTop + offset, behavior: "smooth" });
};
